// extracted by mini-css-extract-plugin
export default {"wrapper":"Category_wrapper__AQd7j","articleTitle":"Category_articleTitle__ezbzn","articleWrapper":"Category_articleWrapper__LP6xM"};